import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Area(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    d: "M5.015.536c.152 0 .299.06.407.169l3.903 3.903a.575.575 0 11-.813.814L5.55 2.459v11.972h12.032l-3.004-3.003a.575.575 0 01.814-.814l3.904 3.904a.575.575 0 010 .813l-3.904 3.904a.575.575 0 11-.814-.813l2.842-2.84H4.4V2.538L1.518 5.422a.575.575 0 01-.813-.814L4.608.705a.575.575 0 01.407-.169z"
  }));
}

export { Area };
//# sourceMappingURL=Area.js.map